import * as React from "react";
import { Admin, Resource } from 'react-admin';
import AuthProvider from './AuthProvider';
import DataProvider from './DataProvider';
import Dashboard from './Dashboard';
import { UserList, UserShow, UserEdit, UserCreate } from './user';
import { DevList, DevShow } from './device';
import { TrackShow } from './track';
//import { PeopleIcon } from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/People';
import CarsIcon from '@material-ui/icons/DirectionsCar';
// import CarsIcon from '@material-ui/icons/DirectionsCar';
// import logo from './logo.svg';
import './App.css';

const App = () => (
  <Admin title="goe.proton-group.ru" authProvider={AuthProvider} dashboard={Dashboard} dataProvider={DataProvider}>
    <Resource name="device/id" options={{ label: 'Устройства' }} list={DevList} show={DevShow} icon={CarsIcon} />
    <Resource name="track" options={{ label: 'Трек' }} show={TrackShow} />
    <Resource name="user" options={{ label: 'Пользователи' }} list={UserList} show={UserShow} edit={UserEdit} create={UserCreate} icon={PeopleIcon} />
  </Admin>
);

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

export default App;
